
export const generateYearOptions = (response: number[]) => {
    if (response.length === 1) {
        return [{ label: response[0], value: response[0] }];
    }

    const [start, end] = response;
    return Array.from({ length: end - start + 1 }, (_, i) => ({
        label: start + i,
        value: start + i
    }));
}
